import  { useState } from "react";

const PersonalDetails = ({
  newEmployee,
  setNewEmployee,
  setImageFile,
  imagePreview,
  setImagePreview,
  imageName,
  setImageName,
}) => {
  const [showPreview, setShowPreview] = useState(false);


  // When user selects an image file
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      setImageName(file.name);
      // Also update parent state for image_profile if you want
      setNewEmployee((prev) => ({ ...prev, image_profile: file.name }));
    }
  };

  return (
    <>
      {/* Profile Image Upload */}
      <div className="col-md-6 col-sm-12 mb-3">
        <label htmlFor="image-upload" className="form-label">Profile Image</label>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Choose an image"
            value={imageName}
            readOnly
          />
          <input
            type="file"
            id="image-upload"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: "none" }}
          />
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => document.getElementById("image-upload").click()}
          >
            <i className="bi bi-camera"></i>
          </button>
          {imagePreview && (
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => setShowPreview(true)}
            >
              <i className="bi bi-eye"></i>
            </button>
          )}
        </div>
      </div>

      {/* Image Preview Modal */}
      {showPreview && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          onClick={() => setShowPreview(false)}
        >
          <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content p-4 text-center">
              <div
                style={{
                  width: "150px",
                  height: "150px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  margin: "0 auto",
                }}
              >
                <img
                  src={imagePreview}
                  alt="Preview"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
              <button className="btn btn-secondary mt-3" onClick={() => setShowPreview(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Name Fields */}
      <div className="row mb-3">
        <div className="col-md-4">
          <label className="form-label">First Name</label>
          <input
            type="text"
            className="form-control"
            value={newEmployee.first_name}
            onChange={(e) => setNewEmployee({ ...newEmployee, first_name: e.target.value })}
            required
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">Middle Name</label>
          <input
            type="text"
            className="form-control"
            value={newEmployee.middle_name}
            onChange={(e) => setNewEmployee({ ...newEmployee, middle_name: e.target.value })}
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">Last Name</label>
          <input
            type="text"
            className="form-control"
            value={newEmployee.last_name}
            onChange={(e) => setNewEmployee({ ...newEmployee, last_name: e.target.value })}
            required
          />
        </div>
      </div>

      {/* Personal Info */}
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Date of Birth</label>
          <input
            type="date"
            className="form-control"
            value={newEmployee.date_of_birth}
            onChange={(e) => setNewEmployee({ ...newEmployee, date_of_birth: e.target.value })}
            required
          />
        </div>

        <div className="col-md-4">
          <label>Gender</label>
          <select
            className="form-control"
            value={newEmployee.gender}
            onChange={(e) => setNewEmployee({ ...newEmployee, gender: e.target.value })}
            required
          >
            <option value="">Select Gender</option>
            <option value="Female">Female</option>
            <option value="Male">Male</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="col-md-4">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={newEmployee.email}
            onChange={(e) => setNewEmployee({ ...newEmployee, email: e.target.value })}
            required
          />
        </div>
      </div>

      {/* Phone Number */}
      <div className="col-md-4 mb-3">
        <label>Phone Number</label>
        <div className="d-flex">
          <span className="form-control w-auto px-3">+91</span>
          <input
            type="text"
            className="form-control"
            placeholder="000-000-000-0"
            maxLength="10"
            value={newEmployee.phone_number || ""}
            onChange={(e) => setNewEmployee({ ...newEmployee, phone_number: e.target.value })}
            required
          />
        </div>
      </div>
    </>
  );
};

export default PersonalDetails;
